import { render, staticRenderFns } from "./SettlementDetail.vue?vue&type=template&id=51ea8e36&scoped=true"
import script from "./SettlementDetail.vue?vue&type=script&lang=js"
export * from "./SettlementDetail.vue?vue&type=script&lang=js"
import style0 from "./SettlementDetail.vue?vue&type=style&index=0&id=51ea8e36&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ea8e36",
  null
  
)

export default component.exports